import { createLazyFileRoute } from '@tanstack/react-router';

import AIAgentsPage from '@src/pages/Platform/AIAgents/AIAgents';

export const Route = createLazyFileRoute('/platform/ai-agents')({
  component: AIAgentsPage,
});
